import React from 'react';

const Standings = ({ standings }) => {
  if (!standings || standings.length === 0) return null;

  return (
    <div className="border-2 border-[#658d71] p-3 sm:p-6 bg-[rgba(0,0,0,0.05)] w-full overflow-hidden">
      <h3 className="text-base sm:text-xl font-bold tracking-widest text-[#d8ceb3] mb-4 uppercase">AL East Standings</h3>
      <div className="overflow-x-auto -mx-1">
        <table className="w-full text-left border-collapse" style={{ minWidth: '420px' }}>
          <thead>
            <tr className="border-b-2 border-[#8aa890] text-[#a9c9b1] text-[10px] uppercase tracking-widest bg-[rgba(0,0,0,0.1)]">
              <th className="p-2 w-8 text-center">RK</th>
              <th className="p-2">Team</th>
              <th className="p-2 text-center">W</th>
              <th className="p-2 text-center">L</th>
              <th className="p-2 text-center">PCT</th>
              <th className="p-2 text-center">GB</th>
              <th className="p-2 text-center">STRK</th>
              <th className="p-2 text-center">L10</th>
            </tr>
          </thead>
          <tbody>
            {standings.map((team, idx) => {
              const isRedSox = team.team.id === 111;
              return (
                <tr key={team.team.id} className={`border-b border-[rgba(101,141,113,0.3)] last:border-0 transition-colors ${isRedSox ? 'bg-[rgba(216,206,179,0.1)]' : 'hover:bg-[rgba(255,255,255,0.03)]'}`}>
                  <td className={`p-2 text-center font-bold tabular-nums text-sm ${isRedSox ? 'text-[#d8ceb3]' : 'text-[#a9c9b1]'}`}>{idx + 1}</td>
                  <td className="p-2">
                    <div className="flex items-center gap-2">
                      <span className={`font-bold text-sm uppercase tracking-wide ${isRedSox ? 'text-[#d8ceb3]' : 'text-white'}`}>
                        {team.team.name}
                      </span>
                      {isRedSox && <span className="bg-[#c4333e] text-white text-[9px] px-1 py-0.5 font-bold rounded">SOX</span>}
                    </div>
                  </td>
                  <td className="p-2 text-center text-white tabular-nums text-sm">{team.wins}</td>
                  <td className="p-2 text-center text-white tabular-nums text-sm">{team.losses}</td>
                  <td className="p-2 text-center text-[#a9c9b1] tabular-nums text-sm">{team.winningPercentage}</td>
                  <td className="p-2 text-center text-[#d8ceb3] tabular-nums font-bold text-sm">{team.gamesBack === '-' ? '0.0' : team.gamesBack}</td>
                  <td className="p-2 text-center text-white tabular-nums text-xs">{team.streak?.streakCode || '--'}</td>
                  <td className="p-2 text-center text-white tabular-nums text-xs">
                    {team.records?.splitSeason?.[0] ? `${team.records.splitSeason[0].wins}-${team.records.splitSeason[0].losses}` : '--'}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Standings;